import React from 'react';
import { Page } from '../Page';
export function PageGLP1Overview() {
  return <Page pageNumber={2} variant="light" data-id="element-1379" data-mp="uk3c91lv04yo">
      <div className="flex flex-col h-full" data-id="element-1380" data-mp="ukuznp5aywdv">
        {/* Title Area */}
        <div className="mb-8" data-id="element-1381" data-mp="zin2vfbee4xd">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1382" data-mp="zhleya9a9ny8">
            Understanding Your Medication
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-2" data-id="element-1383" data-mp="19hm1e52g8k6n">
            What Is GLP-1
          </h1>
          <h1 className="text-5xl font-serif text-tealslate leading-tight mb-5" data-id="element-1384" data-mp="1di5xd5badhr7">
            Medication?
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1385" data-mp="1iaz2huao2s3t" />
        </div>

        {/* Body Text */}
        <div className="space-y-5 mb-10" data-id="element-1386" data-mp="1n7fqmohv96gw">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1387" data-mp="1naley1io84bk">
            If you've taken your first dose already, you've probably started to
            notice something feels different. It might be subtle at first, or it
            might feel obvious right away. You're not as hungry. Meals feel
            smaller. Food isn't constantly on your mind the way it used to be.
            That shift can feel surprising, especially if you're used to relying
            on willpower to manage your eating.
          </p>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1388" data-mp="18812kyglzwws">
            These medications work by mimicking hormones your body already
            produces to regulate appetite, blood sugar, and digestion. The main
            ones you'll hear about are{' '}
            <strong className="text-[#1F1F1F]" data-id="element-1389" data-mp="2010fzd1g7d31">semaglutide</strong>,{' '}
            <strong className="text-[#1F1F1F]" data-id="element-1390" data-mp="1v6w6am0ssqy9">tirzepatide</strong>, and{' '}
            <strong className="text-[#1F1F1F]" data-id="element-1391" data-mp="1r7f17tpa9vtm">liraglutide</strong>. Different
            names, slightly different structures, but they all work in a similar
            way. Instead of introducing something completely new, they take a
            system that already exists in your body and make it stronger and
            more consistent.
          </p>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1392" data-mp="h2lp39o5jbab">
            Your body already produces GLP-1 naturally, but only in small
            amounts that fade quickly after a meal. That's part of why hunger
            can come back sooner than you'd expect, even when you feel like you
            just ate. These medications strengthen that signal and keep it
            around longer, which changes how your body responds to food
            throughout the day.
          </p>
        </div>

        {/* Image */}
        <div className="h-[322px] overflow-hidden mt-auto" data-id="element-1393" data-mp="3kh7yzss2ttma">
          <img src="https://cdn.magicpatterns.com/uploads/whHxfvzA5AKQjVZEmwSxjE/ChatGPT_Image_May_3,_2026,_07_42_50_PM.png" alt="GLP-1 medication injection pen diagram" className="w-full h-full object-contain" data-id="element-1394" data-mp="3kisrlcutz2hi" />
        </div>
      </div>
    </Page>;
}